import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
	link: {
		width: 'max-content',
		fontWeight: 400,
		cursor: 'pointer',
		color: theme.palette.secondary.main,
		textDecoration: 'none',
		'&:hover': {
			color: theme.palette.primary.main,
		},
		'&:focus': {
			color: theme.palette.primary.main,
		}
	},
	secondary: {
		color: theme.palette.secondary.main,
	},
	alternate: {
		fontWeight: 300,
		color: theme.palette.text.primary,
		'&:hover': {
			color: theme.palette.secondary.main,
		},
	},
}));

export default function Link({ text, path, target, variant, href }) {
	const classes = useStyles();

	const classNames = clsx({
		[classes.link]: true,
		[classes.secondary]: variant === 'secondary',
		[classes.alternate]: variant === 'alternate',
	});

	return (
		<>
			{!href && (
				<RouterLink className={classNames} target={target} to={path}>
					{text}
				</RouterLink>
			)}
			{href && (
				<a className={classNames} target={target} href={href}>
					{text}
				</a>
			)}
		</>
	);
}
